import type { SlideOutSide } from '../types';

/**
 * Returns the offscreen translateX for a panel on the given side.
 * A left panel shifts left by its width; a right panel shifts right.
 *
 * @param side - The edge the panel is attached to.
 * @param width - The resolved panel width, including its unit.
 * @returns A CSS translateX value that places the panel fully offscreen.
 */
export function getSideTransform({
  side,
  width,
}: {
  side: SlideOutSide;
  width: string;
}) {
  const sign = side === 'left' ? '-' : '';

  return `translateX(${sign}${width})`;
}
